// Mock data for Phoenix Medical Supply

export const companyInfo = {
  name: "Phoenix Medical Supply",
  tagline: "Connecting Quality Medicine Manufacturers with Healthcare Providers",
  phone: "+1 (555) 123-4567",
  email: "contact@phoenixmedicalsupply.com",
  address: "123 Healthcare Ave, Medical District, City, State 12345"
};

export const heroContent = {
  title: "Your Trusted Bridge to Quality Medical Supplies",
  subtitle: "We connect medicine manufacturers with healthcare providers, ensuring reliable supply chains and competitive pricing for essential pharmaceuticals.",
  cta: "Request a Consultation"
};

export const benefits = [
  {
    id: 1,
    title: "Direct Manufacturer Connections",
    description: "Access to verified pharmaceutical manufacturers for authentic, quality medicines at competitive prices.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Custom Supply Solutions",
    description: "Tailored procurement strategies based on your specific needs, volume requirements, and budget.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Reliable Delivery",
    description: "Efficient logistics and supply chain management ensuring timely delivery of your medical supplies.",
    icon: "Truck"
  },
  {
    id: 4,
    title: "Quality Assurance",
    description: "All products sourced from certified manufacturers meeting international quality standards.",
    icon: "ShieldCheck"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Share Your Requirements",
    description: "Tell us about your medicine needs, quantities, and specifications."
  },
  {
    step: 2,
    title: "We Source & Quote",
    description: "We connect with our manufacturer network to find the best match and pricing."
  },
  {
    step: 3,
    title: "Seamless Delivery",
    description: "Once approved, we coordinate delivery directly to your facility."
  }
];

export const aboutContent = {
  mission: "To bridge the gap between quality medicine manufacturers and healthcare providers, ensuring access to essential pharmaceuticals while maintaining the highest standards of quality and reliability.",
  story: "Phoenix Medical Supply was founded with a clear vision: to simplify the pharmaceutical supply chain. With extensive connections to reputable medicine manufacturers and a deep understanding of healthcare provider needs, we serve as your trusted intermediary in the medical supply industry.",
  values: [
    {
      title: "Quality First",
      description: "We only work with certified manufacturers who meet strict quality standards."
    },
    {
      title: "Transparency",
      description: "Clear communication and honest pricing throughout the entire process."
    },
    {
      title: "Reliability",
      description: "Consistent supply and on-time delivery you can count on."
    },
    {
      title: "Customer Focus",
      description: "Your specific needs drive our sourcing and supply decisions."
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Dr. Sarah Mitchell",
    role: "Hospital Procurement Manager",
    content: "Phoenix Medical Supply has transformed our procurement process. Their manufacturer connections and competitive pricing have helped us maintain quality while managing costs.",
    rating: 5
  },
  {
    id: 2,
    name: "James Rodriguez",
    role: "Pharmacy Chain Owner",
    content: "Reliable, transparent, and always delivers on time. Their custom solutions have been instrumental in keeping our shelves stocked with quality medicines.",
    rating: 5
  }
];

// Mock form submissions storage
export const mockInquiries = [];

export const addInquiry = (inquiry) => {
  mockInquiries.push({
    ...inquiry,
    id: Date.now(),
    timestamp: new Date().toISOString(),
    status: "pending"
  });
  return mockInquiries[mockInquiries.length - 1];
};
